const SchoolSvg = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 11.3333V2.33325C0 1.80282 0.210714 1.29411 0.585787 0.919038C0.960859 0.543966 1.46957 0.333252 2 0.333252H11.3333C11.5101 0.333252 11.6797 0.40349 11.8047 0.528514C11.9298 0.653538 12 0.823108 12 0.999919V12.9999C12 13.1767 11.9298 13.3463 11.8047 13.4713C11.6797 13.5963 11.5101 13.6666 11.3333 13.6666H2.33333C1.71449 13.6666 1.121 13.4208 0.683418 12.9832C0.245833 12.5456 0 11.9521 0 11.3333ZM10.6667 12.3333V10.3333H2.33333C2.06812 10.3333 1.81376 10.4386 1.62623 10.6261C1.43869 10.8137 1.33333 11.068 1.33333 11.3333C1.33333 11.5985 1.43869 11.8528 1.62623 12.0404C1.81376 12.2279 2.06812 12.3333 2.33333 12.3333H10.6667ZM4.66667 1.66659H2C1.82319 1.66659 1.65362 1.73682 1.5286 1.86185C1.40357 1.98687 1.33333 2.15644 1.33333 2.33325V9.22459C1.64579 9.07621 1.98743 8.99946 2.33333 8.99992H10.6667V1.66659H9.33333V6.99992L7 5.66659L4.66667 6.99992V1.66659Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default SchoolSvg
